import gql from "graphql-tag";
const invokeOptiFitQuery = gql(` 
query invokeOptiFit($event: AWSJSON!) {
  invokeOptiFit(event: $event) {
    status
  }
}
`)
export default invokeOptiFitQuery;